'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './JournalFeatured.module.scss'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'
import { Category } from '@/types/singles/category'
import { Image } from '@/types/common/ImageData'

interface JournalFeaturedProps {
    data: DataProps
    full?: boolean;
}

interface ImageProp {
    image: Image;
    imageMobile: Image | null;
}

interface DataProps {
    title: string;
    slug: string;
    featuredImage: ImageProp | null;
    featuredImageHover: ImageProp | null;
    subtitle: string | null;
    categories: Array<Category>;
    writtenBy: string | null;
    secondTitle: string | null;
    isExternal: boolean;
    externalUrl?: LinkExternal | null;
}

export default function JournalFeaturedComplexComponent({
    data, full
}: JournalFeaturedProps) {

    const [hover, setHover] = useState(false);

    const [isMobile, setIsMobile] = useState(false);

    // Detectar si es mobile o desktop
    useEffect(() => {
        const checkScreenSize = () => setIsMobile(window.innerWidth < 768);
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);

        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    return (
        <Link href={`${data.isExternal && data.externalUrl ? data.externalUrl : `/journal/${data.slug}`}`} target={`${data.isExternal && data.externalUrl ? `_blank` : `_self`}`}>
            <div className={`${s.journalFeatured} ${data.featuredImage && s.hasImage}`}>
                <div className={s.text}>
                    {data.categories && data.categories.length > 0 &&
                        <div className={s.category}>
                            <div className={s.categories}>
                                {data.categories && data.categories.map((category: Category, index: number) => {
                                    return (
                                        <span key={`category-${index}`}>{category.title}</span>
                                    )
                                })}
                            </div>
                            <div className={s.arrow}>
                                {data.isExternal && data.externalUrl &&
                                    <span className={s.externalLink}>
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.81674 0.999908C7.81674 0.723765 7.59289 0.499908 7.31674 0.499908L2.81674 0.499908C2.5406 0.499908 2.31674 0.723765 2.31674 0.999908C2.31674 1.27605 2.5406 1.49991 2.81674 1.49991H6.81674V5.49991C6.81674 5.77605 7.0406 5.99991 7.31674 5.99991C7.59289 5.99991 7.81674 5.77605 7.81674 5.49991L7.81674 0.999908ZM0.992188 7.32446L1.34574 7.67802L7.6703 1.35346L7.31674 0.999908L6.96319 0.646354L0.638634 6.97091L0.992188 7.32446Z" fill="black" />
                                        </svg>
                                    </span>
                                }
                            </div>
                        </div>
                    }
                    <div className={s.content}>
                        <h2>{data.title}{data.secondTitle && `: ${data.secondTitle}`}</h2>
                        {data.subtitle && <h3>{data.subtitle}</h3>}
                    </div>
                </div>
                <div
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                >
                    {data.featuredImage &&
                        <div className={`${s.image} ${hover && data.featuredImageHover ? s.hidden : ''} ${full && s.imageFull}`} style={!full ? { aspectRatio: data.featuredImage.image.metadata.dimensions.width / data.featuredImage.image.metadata.dimensions.height } : {}}>

                            {isMobile ? data.featuredImage.imageMobile ? <LazyImage
                                src={data.featuredImage.imageMobile.imageUrl}
                                width={data.featuredImage.imageMobile.metadata.dimensions.width}
                                height={data.featuredImage.imageMobile.metadata.dimensions.height}
                                blurDataURL={data.featuredImage.imageMobile.ref}
                                fill={true}
                                alt={data.featuredImage.imageMobile.attribution || ""}
                                caption={data.featuredImage.imageMobile.caption || null}
                                filename={data.featuredImage.imageMobile.filename || ""}
                            /> : <LazyImage
                                src={data.featuredImage.image.imageUrl}
                                width={data.featuredImage.image.metadata.dimensions.width}
                                height={data.featuredImage.image.metadata.dimensions.height}
                                blurDataURL={data.featuredImage.image.ref}
                                fill={true}
                                alt={data.featuredImage.image.attribution || ""}
                                caption={data.featuredImage.image.caption || null}
                                filename={data.featuredImage.image.filename || ""}
                            /> : <LazyImage
                                src={data.featuredImage.image.imageUrl}
                                width={data.featuredImage.image.metadata.dimensions.width}
                                height={data.featuredImage.image.metadata.dimensions.height}
                                blurDataURL={data.featuredImage.image.ref}
                                fill={true}
                                alt={data.featuredImage.image.attribution || ""}
                                caption={data.featuredImage.image.caption || null}
                                filename={data.featuredImage.image.filename || ""}
                            />}

                        </div>
                    }
                    {data.featuredImageHover &&
                        <div className={`${s.image} ${hover ? '' : s.hidden} ${full && s.imageFull}`} style={!full ? { aspectRatio: data.featuredImageHover.image.metadata.dimensions.width / data.featuredImageHover.image.metadata.dimensions.height } : {}}>
                            {isMobile ? data.featuredImageHover.imageMobile ? <LazyImage
                                src={data.featuredImageHover.imageMobile.imageUrl}
                                width={data.featuredImageHover.imageMobile.metadata.dimensions.width}
                                height={data.featuredImageHover.imageMobile.metadata.dimensions.height}
                                blurDataURL={data.featuredImageHover.imageMobile.ref}
                                fill={true}
                                alt={data.featuredImageHover.imageMobile.attribution || ""}
                                caption={data.featuredImageHover.imageMobile.caption || null}
                                filename={data.featuredImageHover.imageMobile.filename || ""}
                            /> : <LazyImage
                                src={data.featuredImageHover.image.imageUrl}
                                width={data.featuredImageHover.image.metadata.dimensions.width}
                                height={data.featuredImageHover.image.metadata.dimensions.height}
                                blurDataURL={data.featuredImageHover.image.ref}
                                fill={true}
                                alt={data.featuredImageHover.image.attribution || ""}
                                caption={data.featuredImageHover.image.caption || null}
                                filename={data.featuredImageHover.image.filename || ""}
                            /> : <LazyImage
                                src={data.featuredImageHover.image.imageUrl}
                                width={data.featuredImageHover.image.metadata.dimensions.width}
                                height={data.featuredImageHover.image.metadata.dimensions.height}
                                blurDataURL={data.featuredImageHover.image.ref}
                                fill={true}
                                alt={data.featuredImageHover.image.attribution || ""}
                                caption={data.featuredImageHover.image.caption || null}
                                filename={data.featuredImageHover.image.filename || ""}
                            />}
                        </div>
                    }
                </div>
            </div>
        </Link>
    )
}
